import { Stack, Typography } from "@mui/material";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { CustomColumnField, MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../../../api/types/svTypes.ts";
import FormatSettings from "./FormatSettings";

type FormattableField = MeasureField | CustomColumnField;

interface Props {
  measures: FormattableField[];
  onChange: (measure: FormattableField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

const MeasureFieldsContainer = ({ measures, onChange, readonlyMode }: Props) => {
  return (
    <Stack sx={{ gap: 1 }}>
      {measures
        .filter((m) => m.meta.type === ItemDataType.Numeric)
        .map((value) => (
          <FormatSettings
            key={value.config.guid}
            Label={
              <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
                {value.config.customLabel || value.meta.caption}
              </Typography>
            }
            format={value.config.format}
            onUpdateFormatter={(formatter) => onChange(value, { format: formatter })}
            readonlyMode={readonlyMode}
          />
        ))}
    </Stack>
  );
};

export default MeasureFieldsContainer;
